module.exports = __webpack_public_path__ + "img/banner-2.178bf773.png";